const tableConfig = [
  { id: 1, name: 'NUMBER', isSortable: false, info: '', field: 'number' },
  {
    id: 2,
    name: 'TITLE_ONLY',
    isSortable: false,
    info: '',
    field: 'title'
  },
  {
    id: 3,
    name: 'HEADING',
    isSortable: false,
    info: '',
    field: 'articleTitle'
  },
  { id: 4, name: 'DATE', isSortable: true, info: '', field: 'createdDate' }
];

export default tableConfig;
